$(function () {
  //clickHeaderChild();
  hovoerHeaderChild();
  accordion();
  openMenuDrawer();
  textClear();
  headerSearch();
  syncMainPaddingTop();

  $(window).on("resize orientationchange", function () {
    syncMainPaddingTop();
  });

  $(window).on("load", function () {
    syncMainPaddingTop();
  });
});

function syncMainPaddingTop(){
  var $headerSection = $("#shopify-section-header");
  var $mainContent = $("#MainContent");

  if(!$headerSection.length || !$mainContent.length){
    return;
  }

  // メガメニュー(.box-header-bottom)は除外し、閉じた状態のヘッダー高さのみ使う
  var noticeHeight = $headerSection.find(".header-top-notice").outerHeight(true) || 0;
  var topHeight = $headerSection.find(".box-header-top").outerHeight(true) || 0;
  var headerHeight = Math.ceil(noticeHeight + topHeight);

  // SPはヘッダーが position:fixed なので、展開中の検索バー分だけ本文を押し下げる
  if(window.matchMedia("(max-width: 989px)").matches){
    var openSearchHeight = $headerSection.find(".box-search.is-active").outerHeight(true) || 0;
    headerHeight = Math.ceil(noticeHeight + topHeight + openSearchHeight);
  }

  // フォールバック: 構造が違う場合は wrapper から底部を引く
  if(headerHeight <= 0){
    var $wrapper = $headerSection.find(".header-wrapper").first();
    var wrapperHeight = ($wrapper.length ? $wrapper : $headerSection).outerHeight(true) || 0;
    var bottomHeight = $headerSection.find(".box-header-bottom").outerHeight(true) || 0;
    var searchHeight = $headerSection.find(".box-search.is-active").outerHeight(true) || 0;
    headerHeight = Math.ceil(Math.max(wrapperHeight - bottomHeight - searchHeight, 0));
  }

  $mainContent.css("padding-top", headerHeight > 0 ? headerHeight + "px" : "0");
}

function clickHeaderChild(){
  $('.list-menu.list-menu--inline summary').on('click', function(){
    //$(".header__child-menu .header__submenu").removeClass("is-active");
    $(this).toggleClass("is-active")
    var details = $('.list-menu.list-menu--inline summary').index($(this));
    console.log(details)
    if($(".header__child-menu > .header-childmenu-wrap").eq(details).hasClass('is-active')){
      $(".header__child-menu > .header-childmenu-wrap").removeClass("is-active");
    }else{
      $(".header__child-menu > .header-childmenu-wrap").removeClass("is-active");
      $(".header__child-menu > .header-childmenu-wrap").eq(details).addClass("is-active");
    }
  });
  $(document).on('click',function(e) {
    /*if(!$(e.target).closest('.list-menu.list-menu--inline summary').length) {
      // ターゲット要素の外側をクリックした時の操作
      $(".header__child-menu .header__submenu").removeClass("is-active");
    }*/
  });
}

function hovoerHeaderChild(){
  $(".list-menu.list-menu--inline summary").hover(
    function () {
      var details = $('.list-menu.list-menu--inline summary').index($(this));
      if($(this).hasClass('is-active')){
        $(this).removeClass("is-active");
      }else{
        $(this).addClass("is-active");
      }
      if($(".header__child-menu > .header-childmenu-wrap").hasClass('is-active')){
        $(".header__child-menu > .header-childmenu-wrap").stop().slideUp();
        $(".header__child-menu > .header-childmenu-wrap").eq(details).stop().slideDown();
      }else{
        $(".header__child-menu > .header-childmenu-wrap").stop().slideUp();
        $(".header__child-menu > .header-childmenu-wrap").eq(details).stop().slideDown();
      }
    },
    function () {
      var details = $('.list-menu.list-menu--inline summary').index($(this));
      if($(this).hasClass('is-active')){
        //$(this).removeClass("is-active");
      }else{
        $(this).addClass("is-active");
      }
    }
  );
  $(".list-menu.list-menu--inline .link--text,.box-header-top,.header__heading,.header__icons").hover(
    function () {
      $(".list-menu.list-menu--inline summary").removeClass("is-active");
      $(".header__child-menu > .header-childmenu-wrap").stop().slideUp();
    },
    function () {
    }
  );
  $(".header__inline-menu .box-center .menu-close").hover(
    function () {
      $(".list-menu.list-menu--inline summary").removeClass("is-active");
      $(".header__child-menu > .header-childmenu-wrap").stop().slideUp();
    },
    function () {
    }
  );
  $(".header-childmenu-wrap").hover(
    function () {
    },
    function () {
      $(".list-menu.list-menu--inline summary").removeClass("is-active");
      $(".header__child-menu > .header-childmenu-wrap").stop().slideUp();
    }
  );
  $(".header-childmenu-wrap:nth-child(1).online-store").hover(
    function () {
      $(".list-menu.list-menu--inline:nth-child(1) summary").addClass("is-active");
    },
    function () {
    }
  );
  $(".header-childmenu-wrap:nth-child(2)").hover(
    function () {
      $(".list-menu.list-menu--inline:nth-child(2) summary").addClass("is-active");
    },
    function () {
    }
  );
}

function accordion(){
  $(document).on("click", ".accordion-parent", function(e){
    e.preventDefault();
    var $trigger = $(this);
    var $panel = $trigger.next(".accordion-child");

    $trigger.toggleClass("is-active");
    if($panel.length){
      $panel.stop(true, true).slideToggle(200);
    }
    return false;
  });
}

function openMenuDrawer(){
  $("#hamburger-icon-open,#drawer-icon-close").on("click",function(){
    $("#hamburger-icon-open,#drawer-icon-close").toggleClass("is-active")
    $(".header-drawer").toggleClass("is-active");
    $("body").toggleClass("overflow-hidden-tablet");
    closeHeaderSearch();
    return false;
  });
}

function textClear(){
  $(".text_clear").on("click",function(){
    $(this).prev("input[type='search']").val('');
  });
}

function headerSearch(){
  $(document).on("click", ".header .icon-header-search", function(e){
    e.preventDefault();
    var $icon = $(this);
    var $boxSearch = $icon.closest(".box-header-top").nextAll(".box-search");

    if($boxSearch.hasClass("is-active")){
      closeHeaderSearch($boxSearch);
    }else{
      $boxSearch.find("details").attr({'open': 'true'});
      $boxSearch.addClass("is-active");
      $icon.addClass("is-active");
      syncMainPaddingTop();
      // ユーザー操作内で呼ぶことでiOSでもキーボードが開く
      $boxSearch.find("#Search-In-Modal").trigger("focus");
    }
    return false;
  });

  //バツボタン押した時
  $(document).on("click", ".header .search-modal__close-button", function(){
    closeHeaderSearch($(this).closest(".box-search"));
  });

  // details-modal 側の ESC クローズと状態を揃える
  $(document).on("keyup", ".header .box-search", function(e){
    if(e.key === "Escape" || e.keyCode === 27){
      closeHeaderSearch($(this));
    }
  });
}

function closeHeaderSearch($boxSearch){
  if(!$boxSearch || !$boxSearch.length){
    $boxSearch = $(".header .box-search");
  }
  $boxSearch.find("details").removeAttr("open");
  $boxSearch.removeClass("is-active");
  $(".header .icon-header-search").removeClass("is-active");
  syncMainPaddingTop();
}